/**
 * Platform detection + iOS App Store monetization compliance helpers.
 *
 * Apple Guideline 3.1.1 requires that digital subscriptions inside an iOS app
 * use Apple In-App Purchase. Our subscriptions run via Mollie on the web. To
 * stay compliant we use the "Reader App" pattern:
 *  - On iOS we hide pricing, "Abonneren" / "Koop" CTAs and the signup flow.
 *  - Users instead manage their subscription on omasverhaaltjes.nl and log
 *    into the iOS app with an existing account.
 *  - On Android / web everything behaves normally (Mollie flow).
 */
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

export const usePlatform = () => {
  const [platform, setPlatform] = useState('web');

  useEffect(() => {
    setPlatform(Capacitor.getPlatform());
  }, []);

  return {
    platform,
    isNative: Capacitor.isNativePlatform(),
    isIOS: platform === 'ios',
    isAndroid: platform === 'android',
    isWeb: platform === 'web',
    /** True when Apple's Reader App rules apply: hide web purchase UI. */
    hideWebPurchaseUI: platform === 'ios',
  };
};

/**
 * Synchronous version for contexts where hooks can't be used.
 */
export const shouldHideWebPurchaseUI = () =>
  Capacitor.getPlatform() === 'ios';
